import React from "react";
import "@fortawesome/fontawesome-free/js/all";
import PublicSecureFileBrandHeader from "../Shared/PublicSecureFileBrandHeader";
import "../../pages/PublicSecureFile/styles.css";

const AuthPageLayout = ({
  eyebrow = "Telecare Portal",
  title,
  subtitle,
  children,
  footerText = "Access is encrypted and logged for security and compliance purposes.",
}) => (
  <div className="public-secure-file-page">
    <div className="public-secure-file-layout">
      <PublicSecureFileBrandHeader eyebrow={eyebrow} title={title} subtitle={subtitle} />
      <main className="public-secure-file-card">
        <div className="public-secure-file-panel">{children}</div>
      </main>
      <footer className="public-secure-file-footer">
        <i className="fas fa-lock" aria-hidden="true" />
        <span>{footerText}</span>
      </footer>
    </div>
  </div>
);

export default AuthPageLayout;
